import { t } from '../../../adapters/translate/translate'
import { customTheme } from '../../../styles/theme'
import { AlertBox } from '../../ui/layout'
import {
  LinkContent,
  ModalDialogBody, ModalDialogClose,
  ModalDialogContent,
  ModalDialogHeader, ModalDialogHeaderTitle,
  ModalDialogOverlay
} from './modal_box_styled'

const FileModal = ({ handleClose, filePath }: any) => {
  return (
    <>
      <ModalDialogOverlay onClick={handleClose} />
      <ModalDialogContent>
        <ModalDialogHeader background={customTheme.colors.gray[300]}>
          <ModalDialogHeaderTitle>{t('Document')}</ModalDialogHeaderTitle>
          <ModalDialogClose onClick={handleClose}>&times;</ModalDialogClose>
        </ModalDialogHeader>
        <ModalDialogBody>
        {filePath && (
          <object data={`${filePath}`} type="application/pdf" width="100%" height="100%">
            <LinkContent>
              <a href={filePath} target="_blank" rel="noreferrer">{t('Access document')}</a>
            </LinkContent>
          </object>
        )}
        </ModalDialogBody>
      </ModalDialogContent>
      <AlertBox />
    </>
  )
}

export default FileModal
